/**
 * used to collect calls to same function and invoke only once. i.e. against view spam, for user interaction apply-delay, etc.
 * after waiting for waitMillis, check every millisecond for consecutive calls. when no new calls were initiated -> execute callback in scope of obj
 *
 * @param {Object} obj object with named function or lockObject, scope for callback
 * @param {String | function} funcName a function name in obj or a named function
 * @param {int} [waitMillis] defaults to 1. time to wait before invoking func last call wins.
 */
import _ from 'lodash';

export const invokeLast = (obj, funcName, waitMillis) => {
	if (!waitMillis || waitMillis < 0) waitMillis = 1;
	var func;
	if (typeof funcName === 'function') {
		func = funcName;
		funcName = funcName.name
	} else {
		func = obj[funcName];
	}
	var cAttrName = '_ct-' + funcName;

	function recheck() {
		if (obj[cAttrName]) {
			obj[cAttrName] = 0;
			setTimeout(recheck, waitMillis);
		} else {
			obj[cAttrName] = undefined;
			func.call(obj);
		}
	}

	if (obj[cAttrName] === undefined) {
		obj[cAttrName] = 0;
		setTimeout(recheck, waitMillis);
	} else {
		obj[cAttrName]++;
	}
};


export const invokeLastFunc = (obj, funcName, waitMillis) => {
	if (_.isArray(funcName)) {
		let ret = {};
		_.each(funcName, function (fn) {
			ret[fn] = invokeLastFunc(obj, fn, waitMillis);
		});
		return ret;
	} else {
		return function () {
			invokeLast(obj, funcName, waitMillis);
		};
	}
};